/*
 * filename: table.js
 * Get the user data from store and show
 * */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import RaisedButton from 'material-ui/RaisedButton';
import { Field, reduxForm, reset } from 'redux-form';
import Highcharts from 'highcharts';
import Exporting from 'highcharts/modules/exporting';
import ExportingData from 'highcharts/modules/export-data';
import { renderAutoCompleteScheduling, renderCheckBox, renderDateField } from '../components/reduxFields';
import { getOrganizationFinancialKPIGraph } from '../modules/Dashboards/actions/StaffDashboardActions';
import { currencyFormat } from '../actions/utilAction';
Exporting(Highcharts);
ExportingData(Highcharts);
/**
 * A simple table demonstrating the hierarchy of the `Table` component and its sub-components.
 */

//const validatefinancialStaffIds = (value) => !(value ? value.trim() : value) ? 'Please enter staff name.' : undefined;

class FinancialKPI_PROFITANALYSIS extends Component {

  constructor(props) {
    super(props);        
    this.state = {        
        xAxisDateOption: [],  
        isReset: false
      };    
  }

  // loadOrganizationBillableHoursGraph() {
  //   let searchObj3 = {
  //     contain_filters: {
  //       fromDate: this.state.FromFinancialDate ? moment(this.state.FromFinancialDate).format('YYYY-MM-DD') : new Date(),
  //       toDate: this.state.ToFinancialDate ? moment(this.state.ToFinancialDate).format('YYYY-MM-DD') : new Date(),
  //       payerIds: [],
  //       appointmentTypeIds: [],
  //       staffIds: [],
  //       patientIds: [],
  //       locationIds: [],
  //       //IsBillable: isBillable ? true : false, 
  //     }, 
  //   };
  //   this.props.getOrganizationFinancialKPIGraph(searchObj3);
  // }

  componentDidMount = () => {
    this.highchartsHandler();
  }

  componentDidUpdate = () => {
      if(this.props.financialDataAnalytics !== null) {
          this.highchartsHandler();
      }
  }

  handleReset = () => {
    this.props.dispatch(reset('FinancialKPI_PROFITANALYSISForm'));    
    this.props.handleResetFinancialKPI();
  };

  generateFinancialKPIProfitAnalysis = () => {    
    this.props.generateFinancialKPIProfitAnalysis();
  };

  highchartsHandler = () => {
    let finalData = [];
    let xAxisLabel = 'Amount($)';
    let yAxisLabel = 'Staff Name'; 
    let gridlinesWidth = this.props.hideGridlines ? 0 : 1;
    let totalBilledAmount = 0;    
    let totalBilledAmountToDisplay ='';    
    let totalPayrollCost = 0;    
    let totalPayrollCostToDisplay ='';    
    let totalProfit = 0;    
    let totalProfitToDisplay ='';    

    if (this.props.financialDataAnalytics !== null && this.props.financialDataAnalytics.data != null && this.props.financialDataAnalytics.data.patientOrganizationFinancialKPIGraph != null  && this.props.financialDataAnalytics.data.patientOrganizationFinancialKPIGraph.length > 0) {
      this.props.financialDataAnalytics.data.patientOrganizationFinancialKPIGraph.map((obj, index) => {
                    let dataObj = {}
                    dataObj['name'] = obj.name;
                    dataObj['y'] = obj.y ? parseFloat(obj.y.toFixed(2)) : 0.00;
                    totalBilledAmount = totalBilledAmount + parseFloat(obj.x);
                    totalProfit = totalProfit + parseFloat(obj.y);
                    totalPayrollCost = totalPayrollCost + parseFloat(obj.z);
                    finalData.push(dataObj);
                });
                totalBilledAmount = totalBilledAmount.toFixed(2);                
                totalBilledAmountToDisplay = currencyFormat(totalBilledAmount.toString())

                totalProfit = totalProfit.toFixed(2);                
                totalProfitToDisplay = currencyFormat(totalProfit.toString())

                totalPayrollCost = totalPayrollCost.toFixed(2);                
                totalPayrollCostToDisplay = currencyFormat(totalPayrollCost.toString())
    }
    Highcharts.setOptions({
        lang: {
          thousandsSep: ','
        },
        colors: ['#058DC7', '#50B432', '#ED561B', '#DDDF00', '#24CBE5', '#64E572', '#FF9655', '#FFF263', '#6AF9C4']
    });

    Highcharts.chart('analyticsDataDivStaffBilling', {
        chart: {
            type: 'column'
        },
        title: {
            //text: this.props.graphTitle
            text: 'Total Billed: ' + totalBilledAmountToDisplay + ' | Total Payroll Cost: ' + totalPayrollCostToDisplay + ' | Total Profit: ' + totalProfitToDisplay
        },

        yAxis: {
            gridLineWidth: gridlinesWidth,
            minorGridLineWidth: gridlinesWidth,
            title: {
            text: `<b>${xAxisLabel}</b>`
            }
        },

        legend: {
            layout: 'vertical',
            align: 'right',
            verticalAlign: 'middle',
            enabled: false
        },

        xAxis: {
            title: {
                text: `<b>${yAxisLabel}</b>`,
            },
            type: 'category'
        },

        tooltip: {
            enabled: false
        },

        credits: {
            enabled: false
        },

        plotOptions: {
            series: {
                cursor: 'pointer',
                borderWidth: 0,
                dataLabels: {
                    enabled: true
                },
                events: {
                    legendItemClick: function () {
                        return false
                    }
                },
                marker: {
                    enabled: true        
                }
            }
        },

        series: [
            {
                colorByPoint: true,
                data: finalData
            }
        ],

        responsive: {
            rules: [{
                condition: {
                    maxWidth: 500
                },
                chartOptions: {
                    legend: {
                        layout: 'horizontal',
                        align: 'center',
                        verticalAlign: 'bottom'
                    }
                }
            }]
        },

        navigation: {
            buttonOptions: {
                verticalAlign: 'top',
                x: -100
            }
        },

        lang: {
            contextButtonTitle: 'Click to open'
        },

        exporting: {
            buttons: {
                contextButton: {
                    menuItems: ["viewFullscreen", "printChart", "separator", "downloadPNG", "downloadJPEG", "downloadPDF", "downloadSVG", "downloadCSV", "downloadXLS"]
                }
            },
            chartOptions: {
                colors: ['#000000', '#000000', '#000000', '#000000', '#000000', '#000000', '#000000', '#000000', '#000000'],
            }
        }
    });
}
  

  render() {    
    //const { handleSubmit, OrganizationAuthorization } = this.props;
   // const authList =  (OrganizationAuthorization && OrganizationAuthorization.data) || []
    return (
      <div>
        <div className="row">
          <div className="col-sm-12">
                <form className="readmin-form custom_form" >                
                  <div className="row end-flex">         
                    <div className="col-sm-3 ml-10">
                      <Field name="FromFinancialDate"
                        placeholder="From Date"
                        locale="en-US"
                        selected={this.props.FromFinancialDate}
                        onDateChange={this.props.onFinancialKPIDateChange}
                        openToYearSelection={true}
                        component={renderDateField} />
                    </div>
                    <div className="col-sm-3 ml-10">
                      <Field name="ToFinancialDate"
                        placeholder="To Date"
                        locale="en-US"
                        minDate = {this.props.FromFinancialDate}
                        selected={this.props.ToFinancialDate}
                        openToYearSelection={true}
                        onDateChange={this.props.onFinancialKPIDateChange}
                        component={renderDateField} />
                    </div>                 
                    <div className="col-sm-3 ml-10 mt-35">
                      <Field name="financialPayerIds"
                        label="Payer"
                        handleNewRequest={this.props.handleFinancialChange}
                        options={this.props.masterInsuranceCompanies}
                        component={renderAutoCompleteScheduling}
                      />
                    </div>                                                
                    <div className="col-sm-3 ml-10 mt-35">
                      <Field
                        name="financialPatientIds"
                        label="Client"
                        handleNewRequest={this.props.handleFinancialChange}
                        options={this.props.patientlist}
                        component={renderAutoCompleteScheduling}
                        fullWidth={true}
                      />
                    </div>     
                  </div>          
                  <div className="row end-flex">
                    <div className="col-sm-3 mt-35 require">
                      <Field name="financialStaffIds"
                        label="Staff"
                        handleNewRequest={this.props.handleFinancialChange}
                        options={this.props.allStaffs}
                        component={renderAutoCompleteScheduling}
                        //validate={[validatefinancialStaffIds]}
                      />
                    </div>
                    <div className="col-sm-3 mt-35">
                      <Field
                        name="financialLocationIds"
                        label="Location"
                        handleNewRequest={this.props.handleFinancialChange}
                        options={this.props.userLocationList}
                        component={renderAutoCompleteScheduling}
                        fullWidth={true}
                      />
                    </div>                                 
                    <div className="col-sm-3 mt-20">
                      <Field
                        className="mt20 mb0"
                        name="isIncludeMileage"
                        label="Include Mileage"
                        onChange={(e) => this.props.checkFinancialIncludeMileage(e)}
                        component={renderCheckBox}
                      />
                    </div>
                    <div className="col-sm-3 mt-20">
                      <Field
                        className="mt20 mb0"
                        name="isIncludeDriveTime"
                        label="Include Drive Time"
                        onChange={(e) => this.props.checkFinancialIncludeDrivetime(e)}
                        component={renderCheckBox}
                      />
                    </div>
                  </div>
                  <div className="row end-flex">
                    <div className="col-sm-3 mt-20">
                      <Field
                        name="isIncludePaidBreak"
                        label="Include Paid Break"
                        onChange={(e) => this.props.checkFinancialIncludeBreak(e)}
                        component={renderCheckBox}
                      />
                    </div>
                    <div className="col-sm-6 mt-20"></div>                       
                    <div className="reset-btn col-sm-3 btn_rt">
                      <RaisedButton className="grey_btn" onTouchTap={this.generateFinancialKPIProfitAnalysis}>Generate</RaisedButton>
                      <RaisedButton className="grey_btn ml_15" onTouchTap={this.handleReset}>Reset</RaisedButton>
                    </div>
                  </div>
              </form>    
          </div>
        </div>
        <div className='row'>            
            <div className='col-sm-11'>
              {
                  this.props.loading ? "Loading..." :
                  <div>                         
                      {this.state.xAxisDateOption.length > 0 ? 
                      <div className='row'>                          
                          <div className='col-sm-6'></div>
                      </div>   
                      : null}
                      <div id='analyticsDataDivStaffBilling' style={{ height: '500px' }} /> 
                  </div>
              }
            </div>
          </div>        
      </div>
    );
  }
}

FinancialKPI_PROFITANALYSIS = reduxForm({
  form: 'FinancialKPI_PROFITANALYSISForm',  
})(FinancialKPI_PROFITANALYSIS);

function mapStateToProps(state) {   
    //console.log('state.staff_dashboard2............',state.staff_dashboard)
  return {
    financialDataAnalytics: state.staff_dashboard ? state.staff_dashboard.OrganizationFinancialKPIGraph : {},    
    RightPanel_loading: state.staff_dashboard.RightPanel_loading,
  };
}

export default connect(mapStateToProps, { getOrganizationFinancialKPIGraph })(FinancialKPI_PROFITANALYSIS);



// WEBPACK FOOTER //
// ./src/adminCharts/FinancialKPI_PROFITANALYSIS.js